import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";

/* eslint-disable @typescript-eslint/no-explicit-any */
import css from '@styled-system/css';

/**
 * The selectors are based on [WAI-ARIA state properties](https://www.w3.org/WAI/PF/aria-1.1/states_and_properties)
 * and common CSS Selectors
 */
export var pseudoSelectors = {
  _before: '&::before',
  _after: '&::after',
  _hover: '&:hover',
  _active: '&:active, &[data-active=true]',
  _focus: '&:focus',
  _focusWithin: '&:focus-within',
  _visited: '&:visited',
  _empty: '&:empty',
  _even: '&:nth-of-type(even)',
  _odd: '&:nth-of-type(odd)',
  _disabled: '&:disabled, &:disabled:focus, &:disabled:hover, &[aria-disabled=true], &[aria-disabled=true]:focus, &[aria-disabled=true]:hover',
  // prettier-ignore
  _checked: '&[aria-checked=true]',
  _mixed: '&[aria-checked=mixed]',
  _selected: '&[aria-selected=true], [data-selected] > &',
  _invalid: '&[aria-invalid=true]',
  _pressed: '&[aria-pressed=true]',
  _readOnly: '&[aria-readonly=true], &[readonly]',
  _first: '&:first-of-type',
  _last: '&:last-of-type',
  _expanded: '&[aria-expanded=true]',
  _grabbed: '&[aria-grabbed=true]',
  _notFirst: '&:not(:first-of-type)',
  _notLast: '&:not(:last-of-type)',
  _groupHover: '[role=group]:hover &',
  _autofill: '&:-webkit-autofill',
  _placeholder: '&::placeholder'
};
export var pseudoProps = function pseudoProps(_ref) {
  var theme = _ref.theme,
      props = _objectWithoutPropertiesLoose(_ref, ["theme"]);

  var result = {};

  for (var prop in props) {
    if (prop in pseudoSelectors) {
      var _css;

      var pseudoProp = prop;
      var style = css((_css = {}, _css[pseudoSelectors[pseudoProp]] = props[pseudoProp], _css))(theme);
      result = _extends({}, result, style);
    }
  }

  return result;
};